<template>
	<div class="resources">
		<Nav />
		<span class="overlay" :class="{ active: isMenuOpen || isAccessModalOpen }"></span>
		<div class="header header-standard">
			<HeaderNavBar back survey searchType="resources"/>
		</div><!-- header -->
		<div class="header-image lblue"></div><!-- header image -->
		<div class="content-wrap content-wrap-alt content-wrap-nav">
			<div class="has-split">
				<SectionTitle
					icon="ChartIcon"
					:subtitle="'Q' + report.quarter + ' ' + report.year"
					:title="report.title"
					colour="lblue"
				/>
				<img width="90" class="shi-logo" alt="The Seafarers Happiness Index" src="@/assets/shi-logo.png" />
			</div>
			<div class="section-gap text-box report-content" v-html="report.content"/>
            <div v-if="resource" class="section-gap">
                <CardRow
                    eyebrow
                    routeName="ResourcesSingle"
                    :id="resource.id"
                    class="card-row-block-resources card-row-block-alt full"
                    :title="resource.title"
                    :text="resource.simplified_content"
                    tag="Happiness Index"
                    type="Document"
                />
            </div><!-- port card wrap -->
			<div class="section-gap card-wrap">
				<Card
					id=""
					routeName="SurveyTake"
					class="card-block-sky-base card-block-full"
					icon="SurveyIcon"
					title="Take our Survey"
					text="Tell us how you feel"
				/>
			</div><!-- card wrap -->
		</div>
        <AccessModal/>
		<Menu />
	</div>
</template>
<script>
	import HeaderNavBar from '@/components/HeaderNavBar.vue';
	import Nav from '@/components/Nav.vue';
	import Menu from '@/components/Menu.vue';
	import Card from '@/components/Card.vue';
	import CardRow from '@/components/CardRow.vue';
	import SectionTitle from '@/components/SectionTitle.vue';
    import SurveyService from '@/services/SurveyService';
    import AccessModal from '@/components/AccessModal.vue';
	export default {
		name: 'SurveyReport',
		components: {
			Nav,
			HeaderNavBar,
			CardRow,
			Menu,
			Card,
			SectionTitle,
            AccessModal
		},
		data () {
	        return {
                report: {},
                resource: {}
	        };
	    },
	    methods: {
	    	getReport () {
                return SurveyService.getReport(this.$route.params.id).then((response) => {
                    this.report = response.data.report;
                    this.resource = response.data.resource;
                });
            }
	    },
	    computed: {
			isMenuOpen () {
	            return this.$store.state.isMenuOpen;
	        },
            isAccessModalOpen () {
                return this.$store.state.isAccessModalOpen;
            }
		},
		mounted () {
            this.getReport();
        }
	};
</script>
<style scoped lang="scss">
	@import "@/assets/scss/_variables.scss";
	@mixin max_width($breakpoint) {
	    @media only screen and (max-width: $breakpoint) { @content; }
	}
	.has-split {
		display: flex;
		justify-content: space-between;
		align-items: center;
		@include max_width(380px) {
			align-items: flex-start;
		}
		.shi-logo {
			margin-left: 15px;
			@include max_width(380px) {
				width: 85px;
			}
		}
	}
	.card-row-block-resources {
		&.full {
			width: 100%;
			background: $white;
			border-color: $snow;
			box-shadow: 5px 15px 15px 5px $snow;
		}
	}
	.text-box {
		text-align: left;
		p {
			margin-bottom: 25px;
			&:last-of-type {
				margin-bottom: 0;
			}
		}
	}

    .report-content ::v-deep {
        text-align: left;
        margin-bottom: 50px;
        iframe {
            width: 100%;
            margin: 10px 0 30px;
        }
        h2, h3, h4, h5 {
            color: $dark;
            font-size: 17px;
            letter-spacing: -0.5px;
            font-weight: $weight_600;
            line-height: 26px;
            margin-bottom: 30px;
        }
        h6 {
            color: $orange_base;
            font-size: 17px;
            letter-spacing: -0.5px;
            font-weight: $weight_600;
            line-height: 26px;
            margin-bottom: 22px;
            margin-bottom: 30px;
        }
        p {
            margin-bottom: 22px;
            a {
                color: $blue_base;
                text-decoration: underline;
                font-weight: $weight_500;
            }
        }
        ul {
            list-style: disc;
            padding-left: 15px;
            margin-bottom: 25px;
            li {
                font-family: "Inter", sans-serif;
                font-weight: 400;
                letter-spacing: -0.5px;
                font-size: 17px;
                line-height: 1.6em;
                color: #6D7A8B;
                margin-bottom: 10px;
            }
        }
    }

</style>
